module.exports = __webpack_public_path__ + "static/media/weight.f0d45201.svg";